import { removeHttpProtocol } from '@linkie/shared';
import { isPreviewRoute } from './is-preview-route';

export const isCustomDomain = (): boolean => {
  const host = window.location.host;
  return host !== removeHttpProtocol(process.env.CLIENT_URL!) && host !== removeHttpProtocol(process.env.HOME_URL!);
};

export const isPublicPageRoute = (): boolean =>
  Boolean(isPreviewRoute()) || (window.location.pathname === '/' && isCustomDomain());
